//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.07.2015.
 */

(function () {

    'use strict';

    angular.module('container.layout')
        .directive('srsngShell', srsngShell);
        
    function srsngShell() {

        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'container/ui/app/layout/shell.html'
        };
    }
})();
